import { ArrowType } from '@app/react/const/type';
import { ShippingDateReducer } from '@app/react/reducer/ShippingDateReducer';
import { format } from '@app/react/common/dateFormat';

type ConvertShippingDateRet = {
    full?: string,
    semi?: string,
};

export const convertShippingDate = (
    shippingDate: ShippingDateReducer,
    arrowType: ArrowType | null,
): ConvertShippingDateRet => {
    if (arrowType === null) {
        return {};
    }

    const { full, semi } = shippingDate[arrowType];
    if (full === undefined || semi === undefined) {
        return {};
    }

    return {
        full: format(new Date(full)),
        semi: format(new Date(semi)),
    };
};
